import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Hombres de 45 a 65 años que sienten rigidez matutina severa.', 'Trabajadores que pasan muchas horas de pie o sentados y terminan el día agotados.', 'Personas que quieren evitar cirugías de rodilla o cadera en el futuro.', 'Padres y abuelos que no quieren renunciar a su vida activa por el dolor.'];
  const isNotFor = ['Personas que buscan una "cura milagrosa" sin dedicarle 10 minutos a su salud.', 'Atletas profesionales que buscan rendimiento olímpico.', 'Personas con lesiones agudas que requieren intervención quirúrgica inmediata.'];
  return <section className="bg-stone-100 text-stone-800 py-24 px-4 border-t border-stone-200" data-id="element-217">
      <div className="max-w-6xl mx-auto" data-id="element-218">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-219">
          <FadeIn data-id="element-220">
            <div className="bg-white p-8 md:p-10 rounded-3xl shadow-lg border-t-8 border-amber-500 h-full" data-id="element-221">
              <h3 className="text-2xl md:text-3xl font-black mb-8 text-stone-900" data-id="element-222">
                Para quién ES
              </h3>
              <ul className="space-y-6" data-id="element-223">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-224">
                    <div className="bg-amber-100 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-225">
                      <Check className="w-5 h-5 text-amber-700" strokeWidth={3} data-id="element-226" />
                    </div>
                    <span className="text-lg text-stone-600" data-id="element-227">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-228">
            <div className="bg-stone-50 p-8 md:p-10 rounded-3xl shadow-sm border border-stone-200 h-full" data-id="element-229">
              <h3 className="text-2xl md:text-3xl font-black mb-8 text-stone-400" data-id="element-230">
                Para quién NO es
              </h3>
              <ul className="space-y-6" data-id="element-231">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-75" data-id="element-232">
                    <div className="bg-stone-200 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-233">
                      <X className="w-5 h-5 text-stone-500" strokeWidth={3} data-id="element-234" />
                    </div>
                    <span className="text-lg text-stone-500" data-id="element-235">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}